import React from 'react';

import { LayoutComposer, NamedLink } from '../../components';
import GemstoneSiteFooter from '../../components/GemstoneSiteFooter/GemstoneSiteFooter';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import StaticPage from '../PageBuilder/StaticPage';

import css from './ContactPage.module.css';

/* GemstoneX — Contact page. Ported from ui_kits/site/contact/.
   Hero ("Get in touch.") → contact card (trade + general) beside Sydney /
   Bogotá office cards → footer → supplier line. No photography. Topbar +
   footer use the app's global chrome / shared GemstoneSiteFooter. */

const GENERAL_MAILTO = 'mailto:trade@gemstonex.com?subject=General%20inquiry';

const META = {
  title: 'Contact GemstoneX',
  description:
    'Get in touch with GemstoneX. Trade access is by application; general inquiries by email. Offices in Sydney and Bogotá.',
  schema: {
    '@context': 'http://schema.org',
    '@type': 'ContactPage',
    name: 'Contact GemstoneX',
  },
};

const Arrow = props => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <path d="M4 12h15M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ContactPage = () => {
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <StaticPage {...META}>
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage="ContactPage" />
              </Topbar>

              <Main as="main" className={css.main}>
                <div className={css.contact}>
                  {/* Hero */}
                  <header className={css.hero}>
                    <div className={`${css.wrap} ${css.heroInner}`}>
                      <div className={css.eyebrow}>Contact</div>
                      <div className={css.rule} />
                      <h1 className={css.heroTitle}>
                        Get in <em>touch</em>.
                      </h1>
                    </div>
                  </header>

                  {/* Contact card + office addresses */}
                  <section className={css.section}>
                    <div className={css.wrap}>
                      <div className={css.ctGrid}>
                        {/* Primary contact card — both intents, trade path first */}
                        <div className={css.ctContact}>
                          <div className={css.ctIntent}>
                            <div className={css.ctIntentLabel}>Trade buyers &amp; sellers</div>
                            <p>
                              Buying or supplying, access to certified inventory and trade pricing is
                              by application. Apply and our team will verify your credentials.
                            </p>
                            <NamedLink name="TradeAccessPage" className={`${css.btn} ${css.btnPrimary}`}>
                              Apply for Trade Access <Arrow />
                            </NamedLink>
                          </div>

                          <div className={css.ctIntent}>
                            <div className={css.ctIntentLabel}>General inquiries</div>
                            <p>Press, partnerships or a general question.</p>
                            <p className={css.ctIntentEmail}>
                              <a href={GENERAL_MAILTO}>trade@gemstonex.com</a>
                            </p>
                          </div>
                        </div>

                        {/* Office address cards */}
                        <div className={css.ctOffices}>
                          <div className={css.office}>
                            <div className={css.officeLabel}>Sydney · Head office</div>
                            <div className={css.officeName}>GemstoneX Pty Ltd</div>
                            <div className={css.officeReg}>ACN 692 780 117</div>
                            <address className={css.officeAddr}>
                              Level 1, 81–83 Campbell Street
                              <br />
                              Surry Hills NSW 2010
                              <br />
                              Australia
                            </address>
                          </div>
                          <div className={css.office}>
                            <div className={css.officeLabel}>Bogotá · Sourcing</div>
                            <div className={css.officeName}>GemstoneX Col SAS</div>
                            <address className={css.officeAddr}>
                              Carrera 5 No. 15–21
                              <br />
                              Opposite the Emerald Trade Centre
                              <br />
                              Bogotá D.C.
                              <br />
                              Colombia
                            </address>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </Main>

              <Footer>
                <GemstoneSiteFooter showSupplier />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </StaticPage>
  );
};

export default ContactPage;
